
import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { Action } from "vuex-class";
import { download } from "@/functions/global.function";
import AppNavbarSecondary from "@/components/layout/AppNavbarSecondary.vue";
import AppFooter from "@/components/layout/AppFooter.vue";
import { AxiosResponse } from "axios";
import EventDetailItem1 from "@/components/items/event/EventDetailItem1.vue";
import EventDetailItem2 from "@/components/items/event/EventDetailItem2.vue";
import EventDetailItem3 from "@/components/items/event/EventDetailItem3.vue";

@Component({
  components: {
    EventDetailItem3,
    EventDetailItem2,
    EventDetailItem1,
    AppFooter,
    AppNavbarSecondary,
  },
  filters,
})
export default class EventDetail extends Vue {
  @Action("getSchoolEventDetail", { namespace: "school" })
  private getSchoolEventDetail: any;

  private event: any = null;

  private get templateNumber() {
    return Number(this.$route.query.template) || 1;
  }

  private created() {
    this.getSchoolEventDetail({
      params: {
        id: this.$route.params.id,
      },
      success: (response: AxiosResponse) => {
        this.event = response.data.data;
      },
      fail: () => {
        this.$router.push({ name: "landing" });
      },
    });
  }

  private onDownload(data: any) {
    download(data.attachment);
  }
}
